import React, { useContext } from 'react';
import { Table, TableHead, TableRow, TableCell, TableBody, Typography, TableFooter, Button, List, ListItem, ListItemSecondaryAction, IconButton, Grid, ListItemText } from '@mui/material';
import { addOrdersContext } from './AddOrdersContext';
import Moment from 'react-moment';
import { FaPlus } from 'react-icons/fa';
import { SearchType } from 'helpers/Enums';
import moment from 'moment';
import { useIntl } from 'react-intl';
import { LocalizationIds } from 'helpers/Localizations';
import { appUserContext } from 'helpers/services';


let WorkOrderResults = () => {
    let { formatMessage } = useIntl();

    let { isMobile } = useContext(appUserContext);
    let service = useContext(addOrdersContext);

    return <>
        {isMobile === false &&
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell padding="checkbox"></TableCell>
                        <TableCell>{formatMessage({ id: LocalizationIds.WorkOrder })}</TableCell>
                        <TableCell>{formatMessage({ id: LocalizationIds.Customer })}</TableCell>
                        <TableCell>{formatMessage({ id: LocalizationIds.Article })}</TableCell>
                        <TableCell align="center">{formatMessage({ id: LocalizationIds.Quantity })}</TableCell>
                        <TableCell>{formatMessage({ id: LocalizationIds.Order })}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {service.workOrders.map((row, index) =>
                        <TableRow key={index}>
                            <TableCell padding="checkbox">
                                <Button
                                    onClick={(e) => service.onSelect({
                                        type: SearchType.WorkOrders,
                                        orderId: row.orderId,
                                        orderNumber: row.orderNumber,
                                        orderTitle: '',
                                        orderDate: row.orderDate || moment(),
                                        orderType: '',
                                        articleDescription: row.articleDescription,
                                        articleId: row.articleId,
                                        articleModel: row.articleModel,
                                        articleVersion: row.articleVersion,
                                        workOrderId: row.orderRowId,
                                        workOrderNumber: row.workOrder
                                    })}
                                >
                                    <FaPlus />
                                </Button>
                            </TableCell>
                            <TableCell>
                                <b>{row.workOrder}&nbsp;{row.workOrderSub.trim() !== '' && row.workOrderSub.trim() !== "0" && <>-&nbsp;{row.workOrderSub}</>}</b>
                                <Typography variant="subtitle2">{row.orderRowStatus}</Typography>
                            </TableCell>
                            <TableCell>
                                {row.customerName}
                                <Typography variant="subtitle2">{row.customerCountry}</Typography>
                            </TableCell>
                            <TableCell>
                                {row.articleId}&nbsp;{row.articleModel}&nbsp;{row.articleVersion}&nbsp;{row.articleDescription}
                            </TableCell>
                            <TableCell align="center">{row.quantity}</TableCell>
                            <TableCell>
                                {row.orderNumber}&nbsp;&middot;&nbsp;{row.orderRowStatus}
                                <Typography variant="subtitle2">
                                    <Moment date={row.orderDate} format="LL" />
                                </Typography>
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
                {service.workOrders.length === 0 &&
                    <TableFooter>
                        <TableRow>
                            <TableCell colSpan={6}><i>{formatMessage({ id: LocalizationIds.NoWorkOrdersFound })}</i></TableCell>
                        </TableRow>
                    </TableFooter>
                }
            </Table>
        }
        {isMobile === true &&
            <List>
                {service.workOrders.map((row, index) =>
                    <React.Fragment key={index}>
                        <ListItem divider disableGutters>
                            <ListItemSecondaryAction>
                                <IconButton
                                    color="primary"
                                    onClick={(event: any) => {
                                        event.stopPropagation();
                                        service.onSelect({
                                            type: SearchType.WorkOrders,
                                            orderId: row.orderId,
                                            orderNumber: row.orderNumber,
                                            orderTitle: '',
                                            orderDate: row.orderDate || moment(),
                                            orderType: '',
                                            articleDescription: row.articleDescription,
                                            articleId: row.articleId,
                                            articleModel: row.articleModel,
                                            articleVersion: row.articleVersion,
                                            workOrderId: row.orderRowId,
                                            workOrderNumber: row.workOrder
                                        })
                                    }}
                                    size="large">
                                    <FaPlus />
                                </IconButton>
                            </ListItemSecondaryAction>
                            <ListItemText>
                                <Grid container spacing={0}>
                                    <Grid item xs={12}>
                                        <Typography variant="body1">
                                            <b>{formatMessage({ id: LocalizationIds.WorkOrder })}:</b>&nbsp;
                                        </Typography>
                                        <b>{row.workOrder}&nbsp;{row.workOrderSub.trim() !== '' && row.workOrderSub.trim() !== "0" && <>-&nbsp;{row.workOrderSub}</>}</b>
                                        <Typography variant="subtitle2">{row.orderRowStatus}</Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="body1">
                                            <b>{formatMessage({ id: LocalizationIds.Customer })}:</b>&nbsp;
                                        </Typography>
                                        {row.customerName}
                                        <Typography variant="subtitle2">{row.customerCountry}</Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="body1">
                                            <b>{formatMessage({ id: LocalizationIds.Article })}:</b>&nbsp;
                                        </Typography>
                                        {row.articleId}&nbsp;{row.articleModel}&nbsp;{row.articleVersion}&nbsp;{row.articleDescription}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="body1">
                                            <b>{formatMessage({ id: LocalizationIds.Quantity })}:</b>&nbsp;
                                        </Typography>
                                        {row.quantity}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="body1">
                                            <b>{formatMessage({ id: LocalizationIds.Order })}:</b>&nbsp;
                                        </Typography>
                                        {row.orderNumber}&nbsp;&middot;&nbsp;{row.orderRowStatus}
                                        <Typography variant="subtitle2">
                                            <Moment date={row.orderDate} format="LL" />
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </ListItemText>
                        </ListItem>
                    </React.Fragment>
                )}
            </List>
        }
    </>;
}

export default WorkOrderResults;